import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html'
})
export class AlertComponent {
  @Input() type: 'success' | 'danger' | 'warning' | 'info' = 'danger';
  @Input() message: string = '';
  @Input() show: boolean = true;
  @Input() position: 'fixed' | 'relative' = 'fixed';
  @Input() fontSize: number = 16;
  @Output() closed = new EventEmitter<void>();

  getAlertClasses(): string {
    const baseClasses = this.position === 'fixed'
      ? 'fixed left-1/2 top-[calc(1rem+env(safe-area-inset-top,0px))] z-[10020] w-[calc(100%-1.5rem)] max-w-md -translate-x-1/2'
      : 'relative w-full';
    
    switch (this.type) {
      case 'success':
        return `${baseClasses} border-app-supply-border border-l-app-supply bg-app-supply-tint text-app-supply-dark`;
      case 'danger':
        return `${baseClasses} border-app-accent-border-soft border-l-app-accent bg-app-accent-tint text-app-accent-dark`;
      case 'warning':
        return `${baseClasses} border-app-highlight-line border-l-app-highlight bg-app-highlight-soft text-app-highlight-dark`;
      case 'info':
        return `${baseClasses} border-app-brand-border-soft border-l-app-brand bg-app-brand-tint text-app-brand-dark`;
      default:
        return `${baseClasses} border-app-accent-border-soft border-l-app-accent bg-app-accent-tint text-app-accent-dark`;
    }
  }

  getTextClasses(): string {
    switch (this.type) {
      case 'success':
        return 'text-app-supply-dark';
      case 'danger':
        return 'text-app-accent-dark';
      case 'warning':
        return 'text-app-highlight-dark';
      case 'info':
        return 'text-app-brand-dark';
      default:
        return 'text-app-accent-dark';
    }
  }

  getIconClasses(): string {
    switch (this.type) {
      case 'success':
        return 'bg-app-supply text-white';
      case 'danger':
        return 'bg-app-accent text-white';
      case 'warning':
        return 'bg-app-highlight text-app-ink';
      case 'info':
        return 'bg-app-brand text-white';
      default:
        return 'bg-app-accent text-white';
    }
  }

  getButtonClasses(): string {
    switch (this.type) {
      case 'success':
        return 'text-app-supply-dark';
      case 'danger':
        return 'text-app-accent-dark';
      case 'warning':
        return 'text-app-highlight-dark';
      case 'info':
        return 'text-app-brand-dark';
      default:
        return 'text-app-accent-dark';
    }
  }

  getAlertStyle(): Record<string, string> {
    const style: Record<string, string> = {
      'font-size': `${this.fontSize}px`
    };

    return style;
  }

  onClose(): void {
    this.show = false;
    this.closed.emit();
  }
}
